// Module
var code = `<onboarding-checklist heading="onboardingChecklist.title" steps="\$ctrl.steps"></onboarding-checklist>`;
// Exports
module.exports = code;